import { isBandsDomain, isVenueDomain } from "shared/utils";

// SSO does't work on localhost, because we can't set cookies on root domain
const getLocalCookieDomain = () => {
  // if TM_ENV explicitly set, store cookies on localhost
  if (process.env.REACT_APP_TM_ENV) return "localhost";

  if (isBandsDomain) return ".app.localhost";
  if (isVenueDomain) return ".venues.localhost";

  return "localhost";
};

let config: { [key: string]: any } = {
  AWS: {
    // dev and local aws settings
    region: "eu-central-1",
    identityPoolId: "eu-central-1:b85b588b-b69c-426d-bffb-6429880d44f3",
    userPoolId: "eu-central-1_TK5jjek5U",
    userPoolWebClientId: "1bo6ejs542j0g772tljpvd0ldj",
  },
  sentry: {
    dsn: "https://e3c288135db9e2541b8703023cdc290f@o4505034614898688.ingest.us.sentry.io/4505759003246592",
  },
  reCaptcha: {
    sitekey: "6LeeH8AaAAAAADIJD-_XcNlbf35AvFIBz4H1TQXz",
  },
  googleAnalytics: {
    trackingId: "G-YTH6XGCMCS",
  },
};

const env = process.env.REACT_APP_ENV || "local";

console.log("👾", env);

switch (env) {
  case "local": {
    config = {
      ...config,
      mapbox: {
        accessToken:
          "pk.eyJ1IjoidG91cm1hbmFnZW1lbnQiLCJhIjoiY2tpZnZhYXlpMGk1ZDJ0cWtpaWpuNWF5OCJ9.oqdn3MRJaIqBFSOLuCTv3g",
      },
      AWS: {
        ...config.AWS,
        cookieStorage: {
          domain: getLocalCookieDomain(),
          secure: false,
          path: "/",
          expires: 365,
        },
      },
      api: process.env.REACT_APP_LOCAL_API_DOMAIN || "https://api.devtour.be",
      app: "https://app.devtour.be",
    };
    break;
  }
  case "development": {
    config = {
      ...config,
      mapbox: {
        accessToken:
          "pk.eyJ1IjoidG91cm1hbmFnZW1lbnQiLCJhIjoiY2tpZnZhYXlpMGk1ZDJ0cWtpaWpuNWF5OCJ9.oqdn3MRJaIqBFSOLuCTv3g",
      },
      AWS: {
        ...config.AWS,
        cookieStorage: {
          domain: ".devtour.be",
          secure: true,
          path: "/",
          expires: 365,
        },
      },
      api: "https://api.devtour.be",
      app: "https://app.devtour.be",
    };
    break;
  }
  case "staging": {
    config = {
      ...config,
      mapbox: {
        accessToken:
          "pk.eyJ1IjoidG91cm1hbmFnZW1lbnQiLCJhIjoiY2tpZnZhYXlpMGk1ZDJ0cWtpaWpuNWF5OCJ9.oqdn3MRJaIqBFSOLuCTv3g",
      },
      AWS: {
        region: "eu-central-1",
        identityPoolId: "eu-central-1:2c9dd9fa-6610-484d-b0b2-3e43f718c0fe",
        userPoolId: "eu-central-1_BAtLD3qUI",
        userPoolWebClientId: "1qj0pmnlgu245jqb1856lsej1h",
        cookieStorage: {
          domain: ".trmgmt.com",
          secure: true,
          path: "/",
          expires: 365,
        },
      },
      api: "https://api.trmgmt.com",
      app: "https://app.trmgmt.com",
    };
    break;
  }
  /* production is the default config, if passing REACT_APP_ENV value fails */
  default:
  case "production": {
    config = {
      ...config,
      mapbox: {
        accessToken:
          "pk.eyJ1IjoidG91cm1hbmFnZW1lbnQiLCJhIjoiY2trZm5ibDMyMGRhdTJvbndweGIzaTE1MiJ9.u-h-6lpldXVvrYAorRRuOg",
      },
      AWS: {
        region: "eu-central-1",
        identityPoolId: "eu-central-1:6abfd67a-b0cf-4e67-92bf-72b6e822f17d",
        userPoolId: "eu-central-1_vn0tdP5wn",
        userPoolWebClientId: "4p1eg0g4jtanrf73dbhbb0mbo7",
        cookieStorage: {
          domain: ".tourmanagement.com",
          secure: true,
          path: "/",
          expires: 365,
        },
      },
      api: "https://api.tourmanagement.com",
      app: "https://app.tourmanagement.com",
    };
    break;
  }
}

export default Object.freeze(config);
